<template>
    <div>
        <eod-search @input="loadHistory" v-if="!hideSearch" v-model="filters" :config="TaskProductHistory.searchConfig"></eod-search>
    <VDataTable dense :loading="loading" :items="historyItems" :headers="headers" locale="nl-BE" :hide-default-footer="historyItems.length <= 15" :items-per-page="15">
        <template v-slot:item.dueAfterDate="{value}">
            {{$moment(value).format('DD/MM/YYYY HH:mm')}}
        </template>
        <template v-slot:item.dueBeforeDate="{value}">
            {{$moment(value).format('DD/MM/YYYY HH:mm')}}
        </template>
        <template v-slot:item.reportedAt="{value}">
           <span v-if="value">{{$moment(value).format('DD/MM/YYYY HH:mm')}}</span>
           <span v-else>/</span>
        </template>
        <template v-slot:item.plan="{value, item}">
            {{ $moment(item.dueAfterDate).format('DD/MM/YYYY HH:mm') }}<template v-if="item.dueBeforeDate"> - {{ $moment(item.dueBeforeDate).format($moment(item.dueAfterDate).isSame(item.dueBeforeDate, 'day')?'HH:mm':'DD/MM/YYYY HH:mm') }}</template>
        </template>
        <template v-slot:item.responsibleUsers="{value, item}">
                <v-tooltip top v-if="value && user.getFullName" v-for="user in value" :key="value.id" >
                    <template v-slot:activator="{on, attrs}">
                        <v-avatar color="primary" class="white--text" v-on="on" v-bind="attrs" size="28">
                            <v-img v-if="user.profilePicture" :src="$eod.getImageUrl(user.profilePicture.key)" contain />
                            <span v-else>{{ user.getInitials() }}</span>
                        </v-avatar>
                        
                    </template>
                    {{ user.getFullName() }}
                </v-tooltip>
        </template>
        <template v-slot:item.project="{value}">
            <v-chip @click="setFilter('projectId', value)" small>{{ value.name }}</v-chip>
        </template>
        <template v-slot:item.product="{value}">
            <v-chip @click="setFilter('productId', value)" small>{{ value.name }}</v-chip>
        </template>
        <template v-slot:item.taskType="{value}">
            <v-chip @click="setFilter('taskTypeId', value)" small>{{ value.name }}</v-chip>
        </template>
        <template v-slot:item.statusCode="{value}">
            <VChip small :color="settings.getStatusCode(value).color" :dark="settings.getStatusCode(value).textColor != 'dark'"><VIcon small left v-text="settings.getStatusCode(value).icon"></VIcon>{{settings.getStatusCode(value).text}}</VChip>
        </template>
        <template v-slot:item.actions="{item}">
            <v-tooltip top v-if="item.response">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small @click="viewResponse(item)" v-bind="attrs" v-on="on"><v-icon small>mdi-eye</v-icon></v-btn>
                </template>
                Antwoord bekijken
            </v-tooltip>
            <v-tooltip top v-if="item.response">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small @click="$emit('startWorkflow', item)" v-bind="attrs" v-on="on"><v-icon small>mdi-clipboard-plus-outline</v-icon></v-btn>
                </template>
                Nieuwe workflow starten
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small @click="viewWorkflow(item)" v-bind="attrs" v-on="on"><v-icon small>mdi-clipboard-outline</v-icon></v-btn>
                </template>
                Workflow bekijken
            </v-tooltip>
            
        </template>
    </VDataTable>
    <eod-workflow-dialog v-if="isWorkflowDialogVisible" v-model="isWorkflowDialogVisible" :workflow="activeWorkflow"></eod-workflow-dialog>
    <eod-dialog v-if="isResponseDialogVisible" cancelText="Sluiten" hide-ok icon="mdi-clipboard-text-outline" iconColor="primary" title="Antwoord" v-model="isResponseDialogVisible" :width="1024" scrollable>
        <eod-response-detail :itemid="activeWorkflow.response.id"></eod-response-detail>
    </eod-dialog>
</div>
</template>
<script>
import { RouterLink } from 'vue-router';
import { VChip, VDataTable, VIcon } from 'vuetify/lib';
import eodWorkflowDialog from './eod-workflow-dialog.vue';
import TaskProductHistory from './../models/taskProductHistory.js';
import eodSearch from './eod-search.vue';
import User from './../models/user.js';
import eodResponseDetail from './eod-response-detail.vue'

export default {
    name: 'eod-product-history',
    components: {
        VDataTable,
        RouterLink,
        VChip,
        VIcon,
        eodWorkflowDialog,
        eodSearch,
        eodResponseDetail
    },
    props: {
        filter: Object,
        items: Array,
        hideSearch: Boolean,
        search: [],
        headers: {
            type: Array,
            default: () => ([
                {
                value:'taskType',
                text: 'Workflow'
            },
            {
                value:'plan',
                text: 'Planningsdatum'
            },
            {
                value:'reportedAt',
                text: 'Uitvoeringsdatum'
            },
            {
                value: 'responsibleUsers',
                text: 'Uitvoerders'
            },
            {
                value:'project',
                text: 'Project'
            },
            
            {
                value:'statusCode',
                text: 'Status'
            },
            {
                value:'actions',
                align: 'end',
                sortable: false,
                width: 100
            }
            ])
        }
    },
    data: () => ({
        settings: require('./../classes/settings.js'),
        loading: false,
        isWorkflowDialogVisible: false,
        isResponseDialogVisible: false,
        activeWorkflow: null,
        historyItems: [],
        TaskProductHistory:TaskProductHistory,
        filters: [],
    }),
    created(){
        if(this.filter){
            this.loadHistory();
        } else if (this.items){
            this.historyItems = this.items;
            this.loadResponsibleUsers();
            this.$emit('loaded', this.historyItems);
        }

        this.loadSearch(this.search);
    },
    watch: {
        search(newVal, oldVal){
            this.loadSearch(newVal);
        }
    },
    methods: {
        loadResponsibleUsers(){
            const userIds = [];
            for (let i = 0; i < this.historyItems.length; i++) {
                const item = this.historyItems[i];
                if(item.responsibleUsers?.[0]){
                    userIds.push(...item.responsibleUsers.map(item => item.id));
                }
            }

            if(userIds[0]){
                this.$eod.get('users', ['id','username','name', 'firstName', 'profilePicture{key}'], {
                    whereIn: [
                        {
                            column: 'id',
                            array: userIds
                        }
                    ]
                }).then(response => {
                    if(response?.data?.data?.users?.edges){
                        const users = response?.data?.data?.users?.edges || [];
                        for (let i = 0; i < this.historyItems.length; i++) {
                            this.historyItems[i].responsibleUsers = this.historyItems[i].responsibleUsers?.map(item => (new User(users.filter(user => user.id == item.id)?.[0] || item)));
                        }
                    }
                })
            }
        },
        loadSearch(val){
            if(val && val[0]){
                for (let i = 0; i < val.length; i++) {
                    const filter = val[i];
                    this.setFilter(filter.key, filter.value);
                }
            }
        },
        loadHistory(){
            const variables = this.$helper.filtersToVariables(this.filters);

            if(this.filter && this.filter.where){
                if(!variables.where){
                    variables.where = [];
                }
                variables.where = [...variables.where, ...this.filter.where];
            }

            variables.orderBy = {
                column: 'dueAfterDate',
                type: 'desc'
            }

            if(this.filter.where){
                for (let i = 0; i < this.filter.where.length; i++) {
                    const whereFilter = this.filter.where[i];
                    if(whereFilter.column == 'projectId'){
                        this.headers[2] = {
                            value: 'product',
                            text: 'Asset'
                        }
                    }
                }
            }

            this.loading = true;
            this.$eod.get('taskProductHistory', ['project{id name}', 'product{id name}', 'parentTask{id name project{id name} company{id name} service{id name} taskType{id name}}', 'jobType{id name}', 'dueBeforeDate','dueAfterDate', 'reportedAt', 'responsibleUsers{id}', 'response{id}', 'statusCode', 'taskType{id name}'], variables)
                .then(response => {
                    
                    if(response && response.data && response.data.data && response.data.data.taskProductHistory){
                        this.historyItems = response.data.data.taskProductHistory.edges;
                        this.loadResponsibleUsers();
                        this.$emit('loaded', this.historyItems);
                    }
                }).finally(() => {
                    this.loading = false;
                });
        },
        viewWorkflow(item){
            this.activeWorkflow = item.parentTask;
            this.isWorkflowDialogVisible = true;
        },
        viewResponse(item){
            this.activeWorkflow = item;
            this.isResponseDialogVisible = true;
        },
        setFilter(key, value){
            if(this.items){
                return this.$emit('filter', key, value);
            }
            const config = TaskProductHistory.searchConfig.filter(searchConfig => (searchConfig.filter === key))?.[0];
            if(config){
                this.filters = [
                    {
                        config: config,
                        result: {
                            name: value.name,
                            description: null,
                            id: value.id,
                            search_title: value.name
                        }
                    }
                ];

                this.loadHistory();
            }
        }
    }
}
</script>